var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('signing-modal',{ref:"signing",attrs:{"visible":_vm.visible,"contract":_vm.contract,"initMethod":_vm.initSigning},on:{"signingSuccessful":_vm.onSuccessfulSigning,"signingCancelled":_vm.emitModalClosedEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }